"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupedListV2_unstable = void 0;
var Utilities_1 = require("../../Utilities");
var GroupedList_styles_1 = require("./GroupedList.styles");
var GroupedListV2_base_1 = require("./GroupedListV2.base");
/**
 * NOTE: GroupedListV2 is "unstable" and meant for preview use. It passes
 * the same test suite as GroupedList but it is an entirely new implementation
 * so it may have bugs and implementation details may change without notice.
 *
 * GroupedListV2 is an API-compatible replacement for GroupedList with a new implementation
 * that addresses issues GroupedList has with virtualizing nested lists under certain
 * conditions.
 */
var GroupedListV2 = (0, Utilities_1.styled)(GroupedListV2_base_1.GroupedListV2Wrapper, GroupedList_styles_1.getStyles, undefined, {
    scope: 'GroupedListV2',
});
exports.GroupedListV2_unstable = GroupedListV2;
GroupedListV2.displayName = 'GroupedListV2_unstable';
//# sourceMappingURL=GroupedListV2.js.map